// @flow
import React, { Component, Fragment } from 'react'
import DetailForm from './components/DetailForm'
import SummaryForm from './components/SummaryForm'
import type { Room as RoomType } from 'src/types'
import { decryptValues } from 'src/ducks/encryption'
import { connect } from 'react-redux'

type Props = {
  pathname: string,
  location: string,
  room: RoomType,
  dispatch: Function,
  isAlignedAtStart?: boolean
}

type State = {
  showSummary: boolean
}

class RoomDetailForm extends Component<Props, State> {
  state = {
    showSummary: false
  }
  componentDidMount() {
    this.props.dispatch(decryptValues())
  }
  showSummary() {
    this.setState({ showSummary: true })
  }

  render() {
    const { room, pathname, location, isAlignedAtStart } = this.props
    const { showSummary } = this.state
    return (
      <Fragment>
        {!showSummary ? (
          <DetailForm
            pathname={pathname}
            room={room}
            location={location}
            isAlignedAtStart={isAlignedAtStart}
          />
        ) : (
          <SummaryForm pathname={pathname} room={room} location={location} />
        )}
      </Fragment>
    )
  }
}

export default connect()(RoomDetailForm)



// WEBPACK FOOTER //
// ./src/containers/RoomDetailForm/index.js